import React from 'react'
import { Grid, TextField, Typography, Select, MenuItem, TextareaAutosize } from '@material-ui/core'
import { bankList } from '@views/signupView'
import Switch from '@material-ui/core/Switch'
import { User } from '@types'

interface RowProfileProps {
  title: string
  data: any
  showInput: boolean
  name?: string
  type?: string
  options?: string[]
  handleUserProfile?: (name: any, value: any) => void
  notBorderBottom?: boolean
  switchAdd?: boolean
  executiveList?: User[]
}

const RowProfile: React.FC<RowProfileProps> = ({
  title,
  data,
  showInput,
  handleUserProfile,
  name,
  notBorderBottom,
  switchAdd,
  executiveList,
  type,
  options
}) => {
  return (
    <Grid
      item
      style={{
        borderBottom: notBorderBottom ? '' : '1px solid lightgray',
        justifyContent: 'space-between',
        display: 'flex',
        padding: '8px 0',
        height: `${
          name === 'comments' && data?.length > 160
            ? '140px'
            : name === 'comments' && data?.length > 140
            ? '130px'
            : name === 'comments' && data?.length > 80
            ? '100px'
            : name === 'comments' && data?.length > 60
            ? '80px'
            : name === 'comments' && data?.length > 40
            ? '70px'
            : '60px'
        }`,
        textAlign: 'end',
        alignItems: 'center'
      }}
    >
      <Typography
        style={{
          fontSize: '16px',
          fontFamily: 'Roboto, sans-serif'
        }}
      >
        {title}
      </Typography>
      {!showInput ? (
        <>
          {switchAdd ? (
            <Switch checked={data} onChange={() => {}} disabled />
          ) : (
            <Typography
              style={{
                color: 'rgb(252, 177, 90)',
                width: `${name === 'comments' && '300px'}`,
                textAlign: 'end'
              }}
            >
              {data}
            </Typography>
          )}
        </>
      ) : name === 'bank' ? (
        <>
          <Select
            variant="outlined"
            name={name}
            required
            style={{
              height: '45px',
              width: '65%'
            }}
            value={data}
            onChange={e => {
              handleUserProfile?.(e.target.name, e.target.value as string)
            }}
          >
            {bankList.map(bankName => (
              <MenuItem value={bankName} key={bankName}>
                {bankName}
              </MenuItem>
            ))}
          </Select>
        </>
      ) : name === 'executive' ? (
        <>
          <Select
            variant="outlined"
            name={name}
            required
            style={{
              height: '45px',
              width: '65%'
            }}
            value={data}
            onChange={e => {
              handleUserProfile?.(e.target.name, e.target.value as string)
            }}
          >
            {executiveList?.map(executive => (
              <MenuItem value={executive.name} key={executive._id}>
                {executive.name}
              </MenuItem>
            ))}
          </Select>
        </>
      ) : name === 'isRejected' ? (
        <>
          <Switch
            name="isRejected"
            checked={data}
            onChange={e => {
              handleUserProfile?.(e.target.name, !data)
            }}
          />
        </>
      ) : name === 'comments' ? (
        <TextareaAutosize
          aria-label="minimum height"
          name={name}
          placeholder="Comentario"
          value={data}
          style={{
            width: '62.8%',
            height: '90%',
            padding: '4px',
            fontFamily: 'inherit',
            letterSpacing: 'inherit',
            color: 'rgba(0, 0, 0, 0.87)',
            borderRadius: '5px',
            borderColor: '#c4c4c4',
            fontSize: '1rem',
            cursor: 'text'
          }}
          onChange={e => {
            handleUserProfile?.(e.target.name, e.target.value)
          }}
        />
      ) : type === 'select' ? (
        <>
          <Select
            variant="outlined"
            name={name}
            required
            style={{
              height: '45px',
              width: '65%'
            }}
            value={data}
            onChange={e => {
              handleUserProfile?.(e.target.name, e.target.value as string)
            }}
          >
            {options?.map(option => (
              <MenuItem value={option} key={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </>
      ) : (
        <TextField
          size="small"
          id="outlined-basic"
          style={{
            width: '65%'
          }}
          name={name}
          value={data}
          label={`${title}`}
          variant="outlined"
          onChange={e => {
            handleUserProfile?.(e.target.name, e.target.value)
          }}
        />
      )}
    </Grid>
  )
}
// NEQUI O BANCOLOMBIA
export default RowProfile
